import ICsvDateOutput from "../ICsvDateOutput";

export default function createCsvDateOutput(): ICsvDateOutput {
  return {
    id: "",
    chengeDate: ""
  };
}
